export default "__VITE_ASSET__DNXJ7j4n__"